module.exports = __webpack_public_path__ + "static/media/2 (46).8abd373a.jpg";